import baseAPI from '@/api';
import { AxiosResponse } from 'axios';
import { QueryFunctionContext } from '@tanstack/react-query';
import { PaginatedResponse } from '@starsoft/common/models';
import { UseRollCompetitionEntriesQueryKeyProps } from './props';
import { RollCompetitionEntriesRequestDto } from '@/services/dto/roll-competition-entries/roll-competition-entries-request.dto';
import { RollCompetitionEntryWithPlaceAndPrize } from '@/models/roll-competition/entries/with-place/inde';

export async function fetchRollCompetitionEntriesWithPlace({
  queryKey,
}: QueryFunctionContext<UseRollCompetitionEntriesQueryKeyProps>): Promise<
  PaginatedResponse<RollCompetitionEntryWithPlaceAndPrize>
> {
  const params: RollCompetitionEntriesRequestDto = queryKey[1];

  const response: AxiosResponse<
    PaginatedResponse<RollCompetitionEntryWithPlaceAndPrize>
  > = await baseAPI.get<
    PaginatedResponse<RollCompetitionEntryWithPlaceAndPrize>
  >(`/roll-competition-entries`, {
    params,
  });

  return response.data;
}
